import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { uptimeMonitorApiRef } from './api/UptimeMonitorApi';
import { UptimeMonitorAPIImpl } from './api/UptimeMonitorApiImpl';

export const uptimeMonitorPlugin = createPlugin({
  id: 'uptime-monitor',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: uptimeMonitorApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi, identityApi }) => {
        return new UptimeMonitorAPIImpl({
          discoveryApi,
          configApi,
          fetchApi,
          identityApi,
        });
      },
    }),
  ],
});

export const UptimeMonitorPage = uptimeMonitorPlugin.provide(
  createRoutableExtension({
    name: 'UptimeMonitorPage',
    component: () =>
      import('./components/WrapperComponent').then(m => m.WrapperComponent),
    mountPoint: rootRouteRef,
  }),
);
